import { INSURANCE_TYPE } from "../../utils/insuranceTypeUtils";

const InsuranceUploadConfirmationPop = ({
  showConfirmationPopup,
  missingFiles,
  selectedCompanies,
  uploadFiles,
  insuranceFlags = {},
  onClose,
  onConfirm,
  isSubmitting = false // ローディング状態のプロパティを追加
}) => {
  if (!showConfirmationPopup) {
    return null;
  }

  const getCompanyFlagStatus = (company, flagKey) => {
    if (company && typeof company === 'object' && company[flagKey] !== undefined) {
      return !!company[flagKey];
    }

    const companyId = typeof company === 'object' && company !== null ? company.id : null;

    if (companyId && insuranceFlags && Object.prototype.hasOwnProperty.call(insuranceFlags, companyId)) {
      const flagInfo = insuranceFlags[companyId];
      if (flagInfo && Object.prototype.hasOwnProperty.call(flagInfo, flagKey)) {
        return !!flagInfo[flagKey];
      }
    }

    return false;
  };

  const getCompanyHasHikiuke = (company) => getCompanyFlagStatus(company, 'has_hikiuke');

  return (
    <div className="confirmation-popup-overlay">
      <div className="confirmation-popup-container">
        <div className="confirmation-popup-content">
          <h2 className="confirmation-title">申請内容確認</h2>

          <div className="confirmation-details">
            {missingFiles.length > 0 ? (
              <>
                {/* 未アップロードファイルがある場合は警告メッセージを表示 */}
                <div className="confirmation-row u-mb-10">
                  <div className="confirmation-label font-big">未アップロードファイル警告</div>
                </div>
                <div className="comment-content comment-content--error">
                  {missingFiles.map((file, index) => (
                    <div key={index} className="confirmation-file-item">
                      <div className="file-path">{file}</div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                {/* ファイルがアップロードされている保険会社のみを表示 */}
                {selectedCompanies
                  .filter((company) => {
                    // companyがオブジェクトかどうかチェック
                    const companyName = typeof company === 'object' && company !== null ? company.name : company;

                    // いずれかのタイプでファイルがアップロードされている場合のみ表示
                    const hasAnyFile =
                      uploadFiles[companyName]?.policy?.length > 0 ||
                      uploadFiles[companyName]?.newContract?.length > 0 ||
                      uploadFiles[companyName]?.maintenance?.length > 0 ||
                      uploadFiles[companyName]?.handbook?.length > 0 ||
                      uploadFiles[companyName]?.hikiuke?.length > 0;

                    return hasAnyFile;
                  })
                  .map((company, index) => {
                    // companyがオブジェクトかどうかチェック
                    const companyName = typeof company === 'object' && company !== null ? company.name : company;
                    const hasHikiuke = getCompanyHasHikiuke(company);
                    if (company.type && company.type === INSURANCE_TYPE.LIFE) {
                      return (
                        <div key={index} className="confirmation-section">
                          <div className="confirmation-row font-medium">
                            <div className="confirmation-label">{companyName}</div>
                          </div>

                          <div className="confirmation-files">
                            {/* 新契約関連 */}
                            {uploadFiles[companyName]?.newContract?.length > 0 ? (
                              uploadFiles[companyName].newContract.map((fileItem, fileIndex) => (
                                <div key={`new-${fileIndex}`} className="confirmation-file-item font-medium">
                                  <div className="file-path">
                                    <span>新契約関連：{uploadFiles[companyName].newContract.length > 1 ? `（${fileIndex + 1}）` : ''}{fileItem.file.name}</span>
                                    <span>1部</span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="confirmation-file-item font-medium">
                                <div className="file-path">
                                  <span>新契約関連：未アップロード</span>
                                </div>
                              </div>
                            )}

                            {/* 保全・収納・支払関連ファイル */}
                            {uploadFiles[companyName]?.maintenance?.length > 0 ? (
                              uploadFiles[companyName].maintenance.map((fileItem, fileIndex) => (
                                <div key={`maint-${fileIndex}`} className="confirmation-file-item font-medium">
                                  <div className="file-path">
                                    <span>保全・収納・支払関連：{uploadFiles[companyName].maintenance.length > 1 ? `（${fileIndex + 1}）` : ''}{fileItem.file.name}</span>
                                    <span>1部</span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="confirmation-file-item font-medium">
                                <div className="file-path">
                                  <span>保全・収納・支払関連：未アップロード</span>
                                </div>
                              </div>
                            )}

                            {/* 引受目安 */}
                            {hasHikiuke && (
                              uploadFiles[companyName]?.hikiuke?.length > 0 ? (
                                uploadFiles[companyName].hikiuke.map((fileItem, fileIndex) => (
                                  <div key={`hikiuke-${fileIndex}`} className="confirmation-file-item font-medium">
                                    <div className="file-path">
                                      <span>引受目安：{uploadFiles[companyName].hikiuke.length > 1 ? `（${fileIndex + 1}）` : ''}{fileItem.file.name}</span>
                                      <span>1部</span>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="confirmation-file-item font-medium">
                                  <div className="file-path">
                                    <span>引受目安：未アップロード</span>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      );
                    } else if (company.type && company.type === INSURANCE_TYPE.SONPO) {
                      return (
                        <div key={index} className="confirmation-section">
                          <div className="confirmation-row font-medium">
                            <div className="confirmation-label">{companyName}</div>
                          </div>

                          <div className="confirmation-files">
                            {/* ハンドブック */}
                            {uploadFiles[companyName]?.handbook?.length > 0 ? (
                              uploadFiles[companyName].handbook.map((fileItem, fileIndex) => (
                                <div key={`new-${fileIndex}`} className="confirmation-file-item font-medium">
                                  <div className="file-path">
                                    <span>ハンドブック：{uploadFiles[companyName].handbook.length > 1 ? `（${fileIndex + 1}）` : ''}{fileItem.file.name}</span>
                                    <span>1部</span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="confirmation-file-item font-medium">
                                <div className="file-path">
                                  <span>ハンドブック：未アップロード</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    }
                  })}
              </>
            )}
          </div>

          {/* ローディング中の表示オーバーレイ */}
          {isSubmitting && (
            <div className="loading-overlay">
              <div className="loading-content">
                <div className="loading-spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <p className="loading-message">申請処理中です...</p>
              </div>
            </div>
          )}

          <div className="action-buttons c-max-mini c-m-center">
            <button
              className="button button-secondary button-medium"
              onClick={onClose}
              disabled={isSubmitting} // ローディング中は無効化
            >
              戻る
            </button>
            {missingFiles.length === 0 && (
              <button
                className="btn btn-primary button-medium"
                onClick={onConfirm}
                disabled={isSubmitting} // ローディング中は無効化
              >
                {isSubmitting ? '処理中...' : '申請確定'} {/* 動的にテキストを変更 */}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceUploadConfirmationPop;
